import React from  'react';
import RightNav from './Home/RightNav';
import { Outlet } from 'react-router-dom';
import Footer from './Home/Footer/Footer';
export default function DefaultLayout() {

    return(
        <>
            <RightNav />
                <Outlet />
            <Footer />
        </>
    )
   
}